import React from 'react';
import PropTypes from 'prop-types';
import { Divider } from './divider';
import { Link } from './link';
import { List } from './list';
import { LogoLink } from './logolink';
import { MobileNavigation } from './mobilenavigation';
import { Title } from './title';
import { RestaurantLocator } from './restaurantlocator';

const menuRenderer = {
    MobileNavigation,
    Divider,
    Link,
    List,
    LogoLink,
    RestaurantLocator,
    Title
};

/**
 * "meta" component that loads in the correct component according to the data in the JS data objects.
 * TODO: investigate. There might be a better way to do this ;)
 *
 * @function
 * @param       {object} props react props to be passed down to the child components. Descriptions of them exist in the sub-components.
 * @constructor
 */
function RenderMenu(props) {
    const {
        children,
        inList,
        openMenu,
        setOpenMenu,
        openMobileMenu,
        setOpenMobileMenu,
        aria,
        role,
        track
    } = props;

    if (!children || !children.length) {
        return null;
    }

    return (
        <>
            {children.map((menuItem, idx) => {
                if (menuRenderer[menuItem.type]) {
                    return React.createElement(menuRenderer[menuItem.type], {
                        key: 'unique' + idx,
                        ...menuItem,
                        inList,
                        openMenu,
                        setOpenMenu,
                        openMobileMenu,
                        setOpenMobileMenu,
                        aria,
                        role,
                        track
                    });
                }

                return null;
            })}
        </>
    );
}

RenderMenu.propTypes = {
    children: PropTypes.array,
    inList: PropTypes.bool,
    openMenu: PropTypes.string,
    setOpenMenu: PropTypes.func,
    openMobileMenu: PropTypes.bool,
    setOpenMobileMenu: PropTypes.func,
    aria: PropTypes.string,
    role: PropTypes.string,
    track: PropTypes.string
};

export { RenderMenu };
